<div class="container-fluid" [ngClass]="{'disable-all':!iCanWrite}">
    <div class="row auditForm">
        <div class="col">
            <form style="padding: 8px 8px 8px 8px;" [formGroup]="auditForm" (ngSubmit)="onAuditSubmit()">
                <div class="row mb-10 mt-10">
                    <h3>{{ 'FULL_CAMPAIGN_AUDIT' | translate }}</h3>
                </div>
                <div class="row mb-10">
                    <div class="col-md-6">
                        <label>{{ 'CPL_LAST_30_DAYS' | translate }}</label>
                    </div>
                    <div class="col-md-6">
                        <input [ngClass]="{ 'is-invalid': submitted && f.cpL30d.errors }" type="number" formControlName="cpL30d"
                            class="form-control" />
                        <div *ngIf="submitted && f.cpL30d.errors" class="invalid-feedback">
                            <div *ngIf="f.cpL30d.errors.required">{{ 'REQUIRED' | translate }}</div>
                        </div>
                    </div>
                </div>
                <div class="row mb-10">
                    <div class="col-md-6">
                        <label>{{ 'CPL_LAST_7_DAYS' | translate }}</label>
                    </div>
                    <div class="col-md-6">
                        <input [ngClass]="{ 'is-invalid': submitted && f.cpL7d.errors }" type="number" formControlName="cpL7d"
                            class="form-control" />
                        <div *ngIf="submitted && f.cpL7d.errors" class="invalid-feedback">
                            <div *ngIf="f.cpL7d.errors.required">{{ 'REQUIRED' | translate }}</div>
                        </div>
                    </div>
                </div>
                <div class="row mb-10">
                    <div class="col-md-6">
                        <label>{{ 'LAST_CALL_WITH_CLIENT' | translate }}</label>
                    </div>
                    <div class="col-md-6">
                        <input
                            [ngClass]="{ 'is-invalid': submitted && f.lastClientCallDate.errors, 'disable-calender':!iCanWrite }"
                            mwlFlatpickr [altInputClass]="'datetime'" [altInput]="true" [convertModelValue]="true"
                            formControlName="lastClientCallDate" class="form-control" />
                        <div *ngIf="submitted && f.lastClientCallDate.errors" class="invalid-feedback">
                            <div *ngIf="f.lastClientCallDate.errors.required">{{ 'REQUIRED' | translate }}</div>
                        </div>
                    </div>
                </div>
                <div class="row mb-10">
                    <div class="col-md-6">
                        <label>{{ 'LAST_EMAIL_SENT' | translate }}</label>
                    </div>
                    <div class="col-md-6">
                        <input
                            [ngClass]="{ 'is-invalid': submitted && f.lastEmailSentDate.errors,'disable-calender':!iCanWrite }"
                            mwlFlatpickr [altInputClass]="'datetime'" [altInput]="true" [convertModelValue]="true"
                            formControlName="lastEmailSentDate" class="form-control" />
                        <div *ngIf="submitted && f.lastEmailSentDate.errors" class="invalid-feedback">
                            <div *ngIf="f.lastEmailSentDate.errors.required">{{ 'REQUIRED' | translate }}</div>
                        </div>
                    </div>
                </div>
                <div class="row mb-10">
                    <div class="col-md-6">
                        <label>{{ 'CAMPAIGN_AND_ADS_LIVE_AND_DELIVERING' | translate }}</label>
                    </div>
                    <div class="col-md-6">
                        <div *ngFor="let o of bitOptions" class="form-check">
                            <input class="form-check-input" type="radio" formControlName="adsLive" [value]="o.value" [id]="'adsLive' + (o.value === null ? 'null' : o.value)">
                            <label class="form-check-label" [for]="'adsLive' + (o.value === null ? 'null' : o.value)">{{ o.title | translate }}</label>
                        </div>
                    </div>
                </div>
                <div class="row mb-10">
                    <div class="col-md-6">
                        <label>{{ 'CAMPAIGN_PRODUCING_LEADS' | translate }}</label>
                    </div>
                    <div class="col-md-6">
                        <div *ngFor="let o of bitOptions" class="form-check">
                            <input class="form-check-input" type="radio" formControlName="producingLeads" [value]="o.value" [id]="'producingLeads' + (o.value === null ? 'null' : o.value)">
                            <label class="form-check-label" [for]="'producingLeads' + (o.value === null ? 'null' : o.value)">{{ o.title | translate }}</label>
                        </div>
                    </div>
                </div>
                <div class="row mb-10">
                    <div class="col-md-6">
                        <label>{{ 'LEADS_CHECKED_IN_REACH' | translate }}</label>
                    </div>
                    <div class="col-md-6">
                        <div *ngFor="let o of bitOptions" class="form-check">
                            <input class="form-check-input" type="radio" formControlName="leadsEmailChecked" [value]="o.value" [id]="'leadsEmailChecked' + (o.value === null ? 'null' : o.value)">
                            <label class="form-check-label" [for]="'leadsEmailChecked' + (o.value === null ? 'null' : o.value)">{{ o.title | translate }}</label>
                        </div>
                    </div>
                </div>
                <div class="row mb-10">
                    <div class="col-md-6">
                        <label>{{ 'NAMING_CONVENTIONS_AND_CREATIVES' | translate }}</label>
                    </div>
                    <div class="col-md-6">
                        <div *ngFor="let o of bitOptions" class="form-check">
                            <input class="form-check-input" type="radio" formControlName="adsSalesMatch" [value]="o.value" [id]="'adsSalesMatch' + (o.value === null ? 'null' : o.value)">
                            <label class="form-check-label" [for]="'adsSalesMatch' + (o.value === null ? 'null' : o.value)">{{ o.title | translate }}</label>
                        </div>
                    </div>
                </div>
                <div class="row mb-10">
                    <div class="col-md-6">
                        <label>{{ 'LOCATION_TARGETING_CORRECT' | translate }}</label>
                    </div>
                    <div class="col-md-6">
                        <div *ngFor="let o of bitOptions" class="form-check">
                            <input class="form-check-input" type="radio" formControlName="locationTargetCorrect" [value]="o.value" [id]="'locationTargetCorrect' + (o.value === null ? 'null' : o.value)">
                            <label class="form-check-label" [for]="'locationTargetCorrect' + (o.value === null ? 'null' : o.value)">{{ o.title | translate }}</label>
                        </div>
                    </div>
                </div>
                <div class="row mb-10">
                    <div class="col-md-6">
                        <label>{{ 'CAMPAIGN_DAILY_BUDGET_MATCH_SUBSCRIPTION' | translate }}</label>
                    </div>
                    <div class="col-md-6">
                        <div *ngFor="let o of bitOptions" class="form-check">
                            <input class="form-check-input" type="radio" formControlName="budgetMatchSubscription" [value]="o.value" [id]="'budgetMatchSubscription' + (o.value === null ? 'null' : o.value)">
                            <label class="form-check-label" [for]="'budgetMatchSubscription' + (o.value === null ? 'null' : o.value)">{{ o.title | translate }}</label>
                        </div>
                    </div>
                </div>
                <div *ngIf="platform == 'Facebook'" class="row mb-10">
                    <div class="col-md-6">
                        <label>{{ 'ADS_REFRESHED_RECENTLY' | translate }}</label>
                    </div>
                    <div class="col-md-6">
                        <div *ngFor="let o of bitOptions" class="form-check">
                            <input class="form-check-input" type="radio" formControlName="adsSetRefreshed" [value]="o.value" [id]="'adsSetRefreshed' + (o.value === null ? 'null' : o.value)">
                            <label class="form-check-label" [for]="'adsSetRefreshed' + (o.value === null ? 'null' : o.value)">{{ o.title | translate }}</label>
                        </div>
                    </div>
                </div>
                <div *ngIf="platform == 'Facebook'" class="row mb-10">
                    <div class="col-md-6">
                        <label>{{ 'DEMOGRAPHIC_TARGETING_CORRECT' | translate }}</label>
                    </div>
                    <div class="col-md-6">
                        <div *ngFor="let o of bitOptions" class="form-check">
                            <input class="form-check-input" type="radio" formControlName="fbDemographicCorrect" [value]="o.value" [id]="'fbDemographicCorrect' + (o.value === null ? 'null' : o.value)">
                            <label class="form-check-label" [for]="'fbDemographicCorrect' + (o.value === null ? 'null' : o.value)">{{ o.title | translate }}</label>
                        </div>
                    </div>
                </div>
                <div *ngIf="platform == 'Google'" class="row mb-10">
                    <div class="col-md-6">
                        <label>{{ 'GOOGLE_ADS_DIRECTING_CORRECT_LANDING_PAGE' | translate }}</label>
                    </div>
                    <div class="col-md-6">
                        <div *ngFor="let o of bitOptions" class="form-check">
                            <input class="form-check-input" type="radio" formControlName="googleAdsCorrectLandingPage" [value]="o.value" [id]="'googleAdsCorrectLandingPage' + (o.value === null ? 'null' : o.value)">
                            <label class="form-check-label" [for]="'googleAdsCorrectLandingPage' + (o.value === null ? 'null' : o.value)">{{ o.title | translate }}</label>
                        </div>
                    </div>
                </div>
                <div *ngIf="platform == 'Google'" class="row mb-10">
                    <div class="col-md-6">
                        <label>{{ 'GOOGLE_CORRECT_KEYWORDS_BEING_USED' | translate }}</label>
                    </div>
                    <div class="col-md-6">
                        <div *ngFor="let o of bitOptions" class="form-check">
                            <input class="form-check-input" type="radio" formControlName="googleKeywordsCorrect" [value]="o.value" [id]="'googleKeywordsCorrect' + (o.value === null ? 'null' : o.value)">
                            <label class="form-check-label" [for]="'googleKeywordsCorrect' + (o.value === null ? 'null' : o.value)">{{ o.title | translate }}</label>
                        </div>
                    </div>
                </div>
                <div *ngIf="platform == 'Google'" class="row mb-10">
                    <div class="col-md-6">
                        <label>{{ 'GOOGLE_NEGATIVE_KEYWORDS_BEING_USED' | translate }}</label>
                    </div>
                    <div class="col-md-6">
                        <div *ngFor="let o of bitOptions" class="form-check">
                            <input class="form-check-input" type="radio" formControlName="googleNegtiveKeywords" [value]="o.value" [id]="'googleNegtiveKeywords' + (o.value === null ? 'null' : o.value)">
                            <label class="form-check-label" [for]="'googleNegtiveKeywords' + (o.value === null ? 'null' : o.value)">{{ o.title | translate }}</label>
                        </div>
                    </div>
                </div>
                <div class="row mb-10">
                    <div class="col-md-6">
                        <label *ngIf="platform == 'Google'">{{ 'LANDING_PAGE_LOADS_CORRECTLY' | translate }}</label>
                        <label *ngIf="platform == 'Facebook'">{{ 'LANDING_PAGE_LOADS_CORRECTLY_FB' | translate }}</label>
                    </div>
                    <div class="col-md-6">
                        <div *ngFor="let o of bitOptions" class="form-check">
                            <input class="form-check-input" type="radio" formControlName="lpLandingPageCorrect" [value]="o.value" [id]="'lpLandingPageCorrect' + (o.value === null ? 'null' : o.value)">
                            <label class="form-check-label" [for]="'lpLandingPageCorrect' + (o.value === null ? 'null' : o.value)">{{ o.title | translate }}</label>
                        </div>
                    </div>
                </div>
                <div class="row mb-10">
                    <div class="col-md-6">
                        <label *ngIf="platform == 'Google'">{{ 'LANDING_PAGE_LOAD_TIME_LONG' | translate }}</label>
                        <label *ngIf="platform == 'Facebook'">{{ 'LANDING_PAGE_LOAD_TIME_LONG_FB' | translate }}</label>
                    </div>
                    <div class="col-md-6">
                        <div *ngFor="let o of bitOptions" class="form-check">
                            <input class="form-check-input" type="radio" formControlName="lpPageTimeLong" [value]="o.value" [id]="'lpPageTimeLong' + (o.value === null ? 'null' : o.value)">
                            <label class="form-check-label" [for]="'lpPageTimeLong' + (o.value === null ? 'null' : o.value)">{{ o.title | translate }}</label>
                        </div>
                    </div>
                </div>
                <div class="row mb-10">
                    <div class="col-md-6">
                        <label *ngIf="platform == 'Google'">{{ 'LANDING_PAGE_LOOKS_RIGHT_MOBILE_DESKTOP' | translate }}</label>
                        <label *ngIf="platform == 'Facebook'">{{ 'LANDING_PAGE_LOOKS_RIGHT_MOBILE_DESKTOP_FB' | translate }}</label>
                    </div>
                    <div class="col-md-6">
                        <div *ngFor="let o of bitOptions" class="form-check">
                            <input class="form-check-input" type="radio" formControlName="lpCrossPlatform" [value]="o.value" [id]="'lpCrossPlatform' + (o.value === null ? 'null' : o.value)">
                            <label class="form-check-label" [for]="'lpCrossPlatform' + (o.value === null ? 'null' : o.value)">{{ o.title | translate }}</label>
                        </div>
                    </div>
                </div>
                <div class="row mb-10">
                    <div class="col-md-6">
                        <label *ngIf="platform == 'Google'">{{ 'CORRECT_OFFER_SHOWN_ON_LANDING_PAGE' | translate }}</label>
                        <label *ngIf="platform == 'Facebook'">{{ 'CORRECT_OFFER_SHOWN_ON_LP_FB' | translate }}</label>
                    </div>
                    <div class="col-md-6">
                        <div *ngFor="let o of bitOptions" class="form-check">
                            <input class="form-check-input" type="radio" formControlName="lpCorrectOfferShown" [value]="o.value" [id]="'lpCorrectOfferShown' + (o.value === null ? 'null' : o.value)">
                            <label class="form-check-label" [for]="'lpCorrectOfferShown' + (o.value === null ? 'null' : o.value)">{{ o.title | translate }}</label>
                        </div>
                    </div>
                </div>
                <div class="row mb-10">
                    <div class="col-md-12">
                        <label>{{ 'INTERNAL_NOTES_OPTIONAL' | translate }}</label>
                        <textarea rows="3" class="form-control" formControlName="internalNotes" [ngClass]="{ 'is-invalid': submitted && f.internalNotes.errors }"
                        [placeholder]="'AUDIT_INTERNAL_NOTES_PLACEHOLDER' | translate"></textarea>
                    </div>
                </div>
                <div class="row mb-10">
                    <div class="col-md-12">
                        <label>{{ 'EXTERNAL_NOTES_OPTIONAL_RECOMMENDED' | translate }}</label>
                        <textarea rows="5" class="form-control" formControlName="externalNotes" [ngClass]="{ 'is-invalid': submitted && f.externalNotes.errors }"
                        [placeholder]="'AUDIT_EXTERNAL_NOTES_PLACEHOLDER' | translate"></textarea>
                    </div>
                </div>
                <div class="row" *ngIf="iCanWrite" style="margin-top: 22px;">
                    <div class="col-md-12">
                        <button type="submit" class="blue-button">{{ 'SAVE' | translate }}</button>
                    </div>
                </div>
            </form>
        </div>
    </div>
</div>
